<template>
  <div class="about-us">
    <innerBanner :banner="banner" />

    <section class="sec1">
      <div class="wp2">
        <h1 class="sec-title h1-36px">{{ $t('aboutUs.txt.1') }}</h1>
        <pictxtRow :data="row1" />
        <pictxtRow :data="row2" :reverse="true" />
      </div>
    </section>
    <section class="sec2">
      <div class="wp2">
        <div class="title">
          <h4>{{ $t('aboutUs.txt.2') }}</h4>
          <h1>{{ $t('aboutUs.txt.3') }}</h1>
        </div>
        <numRow :list="$t('aboutUs.numList')" />
      </div>
    </section>
    <section class="sec3">
      <div class="wp2">
        <pictxtRow :data="row3" />
        <pictxtRow :data="row4" :reverse="true" />
      </div>
    </section>
    <section class="cert-sec" v-if="certTitle.trim() !== ''">
      <div class="wp2">
        <h3>{{ certTitle }}</h3>
        <img
          :src="certPic.data.attributes.url"
          :alt="certTitle"
          class="lozad"
        />
      </div>
    </section>
    <section class="sec4">
      <div class="wp2">
        <div class="title">
          <!-- <span>{{ $t('aboutUs.txt.4') }}</span> -->
          <h1>{{ $t('aboutUs.txt.5') }}</h1>
        </div>
        <div class="video">
          <video autoplay muted loop controls class="lozad">
            <source :data-src="video" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
    <section class="sec5">
      <div class="wp2">
        <h1 class="title">{{ $t('aboutUs.txt.6') }}</h1>
        <brandList :list="brandList" />
      </div>
    </section>
    <section class="sec6">
      <div class="wp2">
        <div class="title">
          <h1>{{ $t('aboutUs.txt.7') }}</h1>
          <p>{{ $t('aboutUs.txt.8') }}</p>
        </div>
        <div class="map">
          <positionMap />
        </div>
        <addressList />
      </div>
    </section>
  </div>
</template>

<script>
import qs from 'qs'
import innerBanner from '@/components/innerBanner'
import pictxtRow from '@/views/aboutUs/modules/pictxtRow'
import numRow from '@/views/aboutUs/modules/numRow'
import brandList from '@/views/aboutUs/modules/brandList'
import positionMap from '@/components/positionMap'
import addressList from '@/views/aboutUs/modules/addressList'
import lozad from 'lozad'

export default {
  name: 'aboutUs',
  components: {
    innerBanner,
    pictxtRow,
    numRow,
    brandList,
    positionMap,
    addressList
  },
  data() {
    return {
      banner: {},
      row1: {},
      row2: {},
      row3: {},
      row4: {},
      video: 'https://di62r15ma5z2i.cloudfront.net/assets/video/ocm9.3.mp4',
      brandList: [],
      certTitle: '',
      certPic: {}
    }
  },
  created() {
    this.getAboutUs()
    this.getBrands()
  },
  mounted() {
    window.scrollTo(0, 0)
    const observer = lozad()
    observer.observe()
  },
  methods: {
    async getAboutUs() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: {
          data: { attributes: res }
        }
      } = await this.$http.get(`${this.$strapiUrl}/about-us?${queryInfo}`)
      this.banner = {
        img: res.banner.data.attributes.url,
        title: res.title,
        desc: res.description
      }
      for (let i = 0; i < 4; i++) {
        this[`row${i + 1}`] = {
          img: res.Rows[i].Details.row_pic.data.attributes.url,
          title: res.Rows[i].Details.row_title,
          desc: res.Rows[i].Details.row_desc
        }
      }
      this.certTitle = res.cert_title
      this.certPic = res.cert_pic
    },
    async getBrands() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(
        `${this.$strapiUrl}/homepage-brands?${queryInfo}`
      )
      this.brandList = res.map((item) => ({
        id: item.id,
        slug: item.attributes.alt,
        img: item.attributes.logo.data.attributes.url
      }))
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.getAboutUs()
      this.getBrands()
      this.enFontFamily =
        newValue === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            }
      this.enBold =
        newValue === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
    }
  }
}
</script>

<style scoped lang="scss">
//about-us
.about-us {
  .sec1 {
    padding: 66px 0 80px;
    .sec-title {
      font-weight: 550;
      margin-bottom: 80px;
      text-align: center;
    }
  }
  .sec2 {
    padding: 66px 0;
    background: url(~@/assets/images/sec-bg.jpg) no-repeat center center / cover;
    .title {
      text-align: center;
      margin-bottom: 32px;
      h4 {
        @extend .h4-20px;
        margin-bottom: 12px;
      }
      h1 {
        @extend .title1;
      }
    }
  }
  .sec3 {
    padding: 80px 0;
  }
  .cert-sec {
    padding-bottom: 80px;
    h3 {
      text-align: center;
      font-family: 'Arial';
      font-style: normal;
      font-weight: 550;
      font-size: 24px;
      line-height: 150%;
      margin-bottom: 32px;
    }
    img {
      display: block;
      height: auto;
    }
  }
  .sec4 {
    padding-bottom: 80px;
    .title {
      text-align: center;
      margin-bottom: 32px;
      span {
        font-weight: 700;
        font-size: 16px;
        line-height: 28px;
        margin-bottom: 8px;
      }
      h1 {
        font-family: 'Arial';
        font-style: normal;
        font-weight: 550;
        font-size: 24px;
        line-height: 150%;
      }
    }
    .video video {
      display: block;
      width: 100%;
    }
  }
  .sec5 {
    padding-bottom: 80px;
    .title {
      text-align: center;
      margin-bottom: 40px;
      @extend .title1;
    }
  }
  .sec6 {
    padding-bottom: 80px;
    .title {
      text-align: center;
      margin-bottom: 40px;
      h1 {
        @extend .title1;
        margin-bottom: 24px;
      }
      p {
        max-width: 680px;
        margin: 0 auto;
        @extend .regular-16px;
      }
    }
    .map {
      max-width: 780px;
      margin: 0 auto 40px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .about-us .sec2,
  .about-us .sec3,
  .about-us .sec1 {
    padding: 40px 0;
  }
  .about-us .cert-sec {
    padding-bottom: 40px;
  }
  .h1-36px {
    font-size: 24px;
  }
  .about-us .sec4 {
    padding-bottom: 40px;
  }
  .about-us .sec4 .title span,
  .about-us .sec2 .title h4 {
    font-size: 14px;
    opacity: 0.5;
    font-weight: normal;
    margin-bottom: 10px;
    line-height: 21px;
  }
  ::v-deep {
    .position-map {
      width: 680px;
      -webkit-transform-origin: 0 0;
      -moz-transform-origin: 0 0;
      -ms-transform-origin: 0 0;
      -o-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scale(0.5);
      -moz-transform: scale(0.5);
      -ms-transform: scale(0.5);
      -o-transform: scale(0.5);
      transform: scale(0.5);
    }
  }
  .about-us .sec6 .map {
    margin-bottom: -100px;
  }
  .about-us .sec6 .title p {
    font-size: 12px;
    text-align: left;
  }
  .about-us .sec6 {
    padding-bottom: 20px;
  }
  .about-us .sec1 .sec-title {
    margin-bottom: 40px;
  }
}
</style>
